import { conditionDetailEditorSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = []

export default function conditionDetailEditorSlice(state = initialState, action) {
    switch (action.type) {
        case conditionDetailEditorSliceDispatch.setFact: {
            return {
                ...state,
                fact: action.payload
            }
        }
        case conditionDetailEditorSliceDispatch.setOperator: {
            return {
                ...state,
                operator: action.payload
            }
        }
        case conditionDetailEditorSliceDispatch.setValue: {
            return {
                ...state,
                value: action.payload
            }
        }
        default:
            return state
    }
}
